<template>

  <v-container>
    <v-form ref="form">

      <v-row >
        <v-col cols="12" sm="12" md="12">
          <v-subheader>Login with your existing beerplanet.net account.</v-subheader>
          <v-text-field label="Email" v-model="email"></v-text-field>
          <v-text-field
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              :type="showPassword ? 'text' : 'password'"
              label="Password"
              v-model="password"
              class="input-group--focused"
              @click:append="showPassword = !showPassword">
          </v-text-field>

          <v-btn color="success" class="mr-4" @click="login">
          Login
          </v-btn>

          <v-btn color="primary" outlined class="mr-4" @click="resetPassword">
          Forgot Password
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="12" >
          <v-subheader>Create a beerplanet.net account so you don't loose your precious tasting notes etc.</v-subheader>
          <v-btn color="primary" class="mr-4" @click="createAccount">
          Create Account
          </v-btn>
          </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="12" >
          <v-subheader>Don't bother me with all this account stuff, just take me to the app as guest.</v-subheader>
          <v-btn color="primary" outlined class="mr-4" @click="guestAccount">
          Guest Account
          </v-btn>
          </v-col>
      </v-row>
    </v-form>
      <v-snackbar v-model="alertShow" top color="red">
        {{alertMessage}}
        <v-btn color="white" outlined x-small @click.native="alertShow = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-snackbar>
  </v-container>
</template>

<script>

export default {
  name: 'Login',
  data() {
    return {
      email: '',
      password: '',
      showPassword: false,
      valid: false,
      alertShow: false,
      alertMessage: '',
    };
  },
  components: {
  },
  methods: {
    login() {
      const data = {
        email: this.email,
        password: this.password,
      };

      this.$webConn.request('app2_login', data).then((result) => {
        this.$root.afterLogin(result);
        // const Token = result.Token;
        // this.$storage.write('token', Token);

        // // also set token for current webconn
        // this.$webConn.setToken(this.$store.state.token);
        // // emmit login event
        // this.$root.$emit('loggedIn');

        // this.$store.state.token = Token;
        // this.$store.state.username = result.Username;
        // this.$store.state.nickname = result.Nickname;
        // this.$store.state.email = result.Email;
        // this.$store.state.avatar = result.Avatar;
        // this.$store.state.loggedIn = true;
        // this.$router.push('/');
      }).catch((error) => {
        alert(error.Message);
      });
    },
    resetPassword() {
      if (this.email.length < 3) {
        this.alertMessage = 'Please enter a valid email address';
        this.alertShow = true;
      } else {
        const data = {
          email: this.email,
        };

        this.$webConn.request('app2_reset_password', data).then((result) => {
          this.alertMessage = 'Password recovert details have been emailed';
          this.alertShow = true;
        }).catch((error) => {
          this.alertMessage = error.Message;
          this.alertShow = true;
        });
      }
    },
    createAccount() {
      // this.$router.push('/account');
      this.$router.push({ name: 'Account', params: { newAccount: true } });
    },
    guestAccount() {
      const data = {
        guest: true,
      };

      this.$webConn.request('app2_create_account', data).then((result) => {
        this.$root.afterLogin(result);
      }).catch((error) => {
        alert(error.Message);
      });
    },
  },
};
</script>
